import './App.css';
import React from 'react';

function App() {
  return (
    <section className="text-gray-700 body-font flex align-center justify-center firstsec">
     <div className="items-center px-5 py-20">
   
          <div class="py-4">
          <section className="text-gray-700 body-font flex align-center justify-center">
    <center>
<div className="flex flex-col items-center bg-white rounded-lg border shadow-md md:flex-row md:max-w-xl hover:bg-gray-100 dark:border-gray-700 dark:bg-gray-800 dark:hover:bg-gray-700">
    <img className="object-cover sm:m-5 w-full h-96 t-lg md:h-auto md:w-48 md-none md-l-lg" src="https://i.ibb.co/TgjYkHn/opemipo-2.jpg" alt="" width=""/>
    <div className="flex flex-col justify-between p-4 leading-normal">
        <h5 className="mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-white">Hi, I'm Opemipo 💫</h5>
        <p className="mb-3 font-normal text-gray-700 dark:text-gray-400">I'm Opemipo Disu, a 17-year-old Developer Advocate at Fermyon 🥑. Currently on a mission to inspire over 1 million developers and make tech accessible for everyone. <br /> You can find me on <a href="https://www.twitter.com/coderoflagos">Twitter</a>, <a href="https://www.linkedin.com/in/coderoflagos">LinkedIn</a>, or <a href="mailto:opemipooluwatobiloba58@gmail.com">Email me</a>.</p>
    </div>
</div>

</center>
</section>
   
        <div>

     <br/><br/><br/><br/><br/><br/>
  </div>
</div>  
           
  
            
  
           
  
           
  
           
            </div>

        
    

    

  

    </section>

    

    
  );
}

export default App;
